<template>
    <div class="viewport">
        <md-toolbar :md-elevation="1">
            <span class="md-title md-list-item-text primary">Klant</span>
            <md-button
                @click="showDialogSelectClient = true"
                class="md-icon-button md-list-action"
                v-if="!isExistingQuote && selectedClient"
            >
                <md-icon>edit</md-icon>
            </md-button>
        </md-toolbar>
        <md-list class="md-double-line">
            <div style="width: 100%; display: flex" v-if="!selectedClient">
                <md-button class="md-primary" @click="showDialogSelectClient = true" style="flex: 1">
                    <md-icon>add</md-icon>
                    Select Client
                </md-button>
            </div>

            <md-list-item v-if="selectedClient">
                <client-card
                    :client="selectedClient"
                    :delivery-address="this.quoteUpsertBody.upsertQuote.data.delivery_address ?? null"
                    style="width: 100%"
                />
            </md-list-item>
        </md-list>
        <md-dialog style="z-index: 9" :md-active.sync="showDialogSelectClient">
            <md-dialog-title
                >Select Client
                <md-list>
                    <md-list-item>
                        <md-icon>face</md-icon>
                        <span class="md-list-item-text">Bestaande klant/lead</span>
                        <md-switch v-model="existingCustomer" />
                    </md-list-item>
                </md-list>
            </md-dialog-title>

            <md-dialog-content>
                <md-list v-if="existingCustomer">
                    <md-list-item>
                        <client-search-modal
                            @set-selected-client="setSelectedClient($event)"
                            @set-selected-delivery-address="setSelectedDeliveryAddress($event)"
                            style="padding-left: 15px; z-index: 1000"
                        >
                        </client-search-modal>
                    </md-list-item>
                </md-list>

                <div v-if="!existingCustomer">
                    <form novalidate @submit.prevent="validateForm">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-50 md-small-size-100">
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('first_name')">
                                        <label for="first_name">Voornaam</label>
                                        <md-input
                                            required
                                            name="first_name"
                                            id="first_name"
                                            v-model="form.first_name"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.first_name.required"
                                            >Verplicht in te vullen!</span
                                        >
                                        <span class="md-error" v-else-if="!$v.form.first_name.minLength"
                                            >Naam is te kort</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('last_name')">
                                        <label for="last_name">Achternaam</label>
                                        <md-input
                                            required
                                            name="last_name"
                                            id="last_name"
                                            v-model="form.last_name"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.last_name.required"
                                            >Verplicht in te vullen!</span
                                        >
                                        <span class="md-error" v-else-if="!$v.form.last_name.minLength"
                                            >Naam is te kort</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('main_address.address')">
                                        <label for="address">Straat</label>
                                        <md-input
                                            required
                                            name="address"
                                            id="address"
                                            v-model="form.main_address.address"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.main_address.address.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('main_address.city')">
                                        <label for="city">Stad</label>
                                        <md-input
                                            required
                                            name="city"
                                            id="city"
                                            v-model="form.main_address.city"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.main_address.city.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('main_address.zip_code')">
                                        <label for="city">Postcode</label>
                                        <md-input
                                            required
                                            name="zip_code"
                                            id="zip_code"
                                            v-model="form.main_address.zip_code"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.main_address.zip_code.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('phone')">
                                        <label for="phone">Tel.nr</label>
                                        <md-input
                                            name="phone"
                                            id="phone"
                                            v-model="form.telephone_phone"
                                            :disabled="sending"
                                        />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('phone')">
                                        <label for="mobile_phone">GSM.nr</label>
                                        <md-input
                                            name="mobile_phone"
                                            id="mobile_phone"
                                            v-model="form.mobile_phone"
                                            :disabled="sending"
                                        />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-size-90 md-small-size-100">
                                    <md-field :class="getValidationClass('email')">
                                        <label for="email">Email</label>
                                        <md-input
                                            required
                                            name="email"
                                            id="email"
                                            v-model="form.email"
                                            :disabled="sending"
                                        />
                                        <span class="md-error" v-if="!$v.form.email.required"
                                            >Verplicht in te vullen!</span
                                        >
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelSelectClient()" class="md-primary">Cancel</md-button>
                <md-button @click="addSelectClient()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAddress, IClientEntity, IUpsertQuoteBody, Language, IClientDataEntity } from '@phrospr/api-backend';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import ClientCard from '@/components/client/ClientCard.vue';
import { quoteStore } from '@/store/quote/quote.store';
import QuoteClientCreate from '@/views/quote2/components/QuoteClientCreate.vue';
import { newClientDataEntity } from '@phrospr/lib-core/src/engine/client.engine';
import { validationMixin } from 'vuelidate';
import { email, minLength, required } from 'vuelidate/lib/validators';
import { IVuelidateComponentOptions } from '@/services/entities/vuelidate.entity';
import * as toastr from 'toastr';

@Component({
    components: { QuoteClientCreate, ClientCard, ClientSearchModal },
    mixins: [validationMixin],
    validations: {
        form: {
            first_name: { required, minLength: minLength(2) },
            last_name: { required, minLength: minLength(2) },
            email: { required, email },
            mobile_phone: {},
            telephone_phone: {},
            gender: {},
            main_address: {
                address: { required },
                city: { required },
                zip_code: { required },
                country: {},
            },
            phone: {},
            company_data: {
                company_name: {},
            },
        },
    },
} as IVuelidateComponentOptions)
export default class QuoteClient extends Vue {
    @Prop() private quoteUpsertBody: IUpsertQuoteBody;

    form: IClientDataEntity = newClientDataEntity();
    existingCustomer = true;
    selectedDeliveryAddress: IAddress = null;
    showDialogSelectClient = false;

    invalidForm = false;
    Language = Language;
    $v: any;
    sending = false;

    get isFilled() {
        return this.selectedClient !== null || this.form !== null;
    }

    get selectedClient() {
        return quoteStore.state.selectedClient;
    }

    get isExistingQuote() {
        return this.quoteUpsertBody.upsertQuote.quoteId !== undefined;
    }

    constructor() {
        super();
        this.load();
    }

    private async load() {
        if (!this.isExistingQuote && quoteStore.state.selectedClient && quoteStore.state.selectedClient.client_data) {
            this.setSelectedDeliveryAddress(quoteStore.state.selectedClient.client_data.main_address);
        }
    }

    public async cancelSelectClient() {
        this.showDialogSelectClient = false;
    }

    public async addSelectClient() {
        if (this.existingCustomer) {
            if (!this.quoteUpsertBody.upsertQuote.data.delivery_address) {
                toastr.error('Geen adres geselecteerd');
            } else {
                this.quoteUpsertBody.client_id = this.selectedClient.client_id;
                this.quoteUpsertBody.newClient = undefined;
                this.showDialogSelectClient = false;
            }
        } else {
            this.quoteUpsertBody.upsertQuote.data.delivery_address = this.form.main_address;
            this.validateForm();
        }
    }

    setSelectedClient(client: IClientEntity) {
        quoteStore.commit('setSelectedClientQuote', client);
    }

    setSelectedDeliveryAddress(address: IAddress) {
        quoteStore.commit('setSelectedAddressClient', address);
    }

    reset() {
        quoteStore.commit('setSelectedClientQuote', null);
        this.quoteUpsertBody.client_id = undefined;
        this.form = null;
    }

    validateForm() {
        this.invalidForm = false;
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.quoteUpsertBody.newClient = this.form;
            this.quoteUpsertBody.client_id = null;
            quoteStore.commit('setSelectedClientQuote', {
                client_data: this.form,
                inactive: false,
                state: null,
                client_settings: null,
                creation_data: null,
                exact_last_sync: null,
                exact_client_number: null,
                client_id: null,
                lead_data: null,
            });
            this.showDialogSelectClient = false;
        } else this.invalidForm = true;
    }

    getValidationClass(fieldName) {
        const keys = fieldName.split('.');
        let field = this.$v.form[keys[0]];
        for (let i = 1; i < keys.length; i++) field = field[keys[i]];
        if (field) {
            return {
                'md-invalid': field.$invalid && field.$dirty,
            };
        }
    }
}
</script>

<style lang="scss" scoped></style>
